import { VisitEncounterMode } from './VisitEncounterModeField.types';

export const VISIT_ENCOUNTER_MODE_ID_MAP: Record<VisitEncounterMode, number> = { ON_SITE: 0, VIDEO_CONSULTATION: 1 };
